/* jshint forin:true, noarg:true, noempty:true, eqeqeq:true, bitwise:true, strict:true, undef:true, unused:true, browser:true, devel:true, jquery:true, indent:4, maxerr:50, boss:true, trailing:true, white:true, sub:true*/
/* globals  jQuery:true, TweenMax:true, window:true, navigator:true, Draggable:true, Power1:true, TimelineMax:true, Power4:true, Spinner:true, Sector:true, Back:true, site:true, Drupal:true, Power2:true*/

(function ($) {
  'use strict';

  Drupal.behaviors.ModuleSupremePower = {
    attach: function (context, settings) {
      // /////////////////////////////////
      // BEGIN: Utility Functions
      // /////////////////////////////////

      /*
      * @function getInternetExplorerVersion
      * @description Returns the version of Internet Explorer or a -1 (indicating the use of another browser).
      * @see: https://msdn.microsoft.com/en-us/library/ms537509(v=vs.85).aspx
      * @returns {Number} -1 if not any IE version, any other number otherwise
      */
      function getInternetExplorerVersion() {
        var rv = -1;
        var ua;
        var re;
        var verStringArr;

        // works up to IE 10 but IE 11 spoofs this value. seperate check for IE Edge
        if (navigator.appName === 'Microsoft Internet Explorer') {
          ua = navigator.userAgent;
          re = new RegExp('MSIE ([0-9]{1,}[\.0-9]{0,})');

          if (re.exec(ua) !== null) {
            rv = parseFloat(RegExp.$1);
          }
        } else if (navigator.appName === 'Netscape' && navigator.userAgent.indexOf('Trident') > -1) {
          rv = 11;
        } else if (navigator.appName === 'Netscape' && navigator.userAgent.indexOf('Edge') > -1) {
          ua = navigator.userAgent;
          re = new RegExp('Edge\/([0-9]{1,}[\.0-9]{0,})');
          verStringArr = re.exec(ua);

          if (verStringArr.length !== 0) {
            rv = Math.floor(parseFloat(verStringArr[0].split('/')[1]));
          }
        }

        return rv;
      }

      // /////////////////////////////////
      // END: Utility Functions
      // /////////////////////////////////
      // DOM Elements
      var MAIN = new Sector({
        loop: true,
        debug: false
      });
      var $window = $(window);
      var $body = $('body');
      var $siteContainer = $('#supreme-power_container');
      var $videoModal = $('.video_container');
      // debug
      var debug = window.location.search.indexOf('debug=true') !== -1 ? true : false;
      // Platform checks
      var isDesktop;
      var isMobile;
      var isIpad;
      var ieVersion;
      var mobileSize;
      var deeplinking = false;
      var productsReady = false;
      // Options
      var options = {
        carousel: {
          increment: '33.3%',
          offset: '0.3%',
          useGSAP: true,
          key_next: 39,
          key_prev: 37,
          duration: 0.5
        },
        video: {
          'debug': false,
          'width': 960,
          'height': 420,
          'autoplay': 1,
          'controls': 0
        },
        videoYoutube: {
          'debug': false,
          'width': 960,
          'height': 420,
          'controls': 0,
          'autohide': 1,
          'rel': 0,
          'autoplay': false,
          'showinfo': 0,
          'modestbranding': 1,
          'playerType': ieVersion >= 10 || ieVersion === -1 ? 'iframe' : 'flash',
          'preferredQuality': 'hd720', // highres
          'iv_load_policy': 3
        }
      };
      var stopScroll = false;

      // Preform platform checks here
      {
        mobileSize = 640;
        isMobile = typeof site !== 'undefined' ? site.client.isMobile : /iphone|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase());
        isDesktop = !isMobile;
        isIpad = navigator.userAgent.toLowerCase().match(/ipad/i) !== null;
        ieVersion = getInternetExplorerVersion();

        // set classes for desktop/mobile/ipad/ie
        if (isIpad) {
          // iPad is considered a desktop variation
          $body.addClass('ipad desktop');
        } else {
          $body.addClass(isMobile ? 'mobile' : 'desktop');
        }

        if (ieVersion !== -1) {
          $body.addClass('ie');
        }

        if (ieVersion === 9) {
          $body.addClass('ie-9');
        }

        // Check if desktop is in mobile size and apply class as necessary
        isMobile = $(window).width() <= mobileSize;

        if (isMobile) {
          $body.addClass('mobile');
        }
      }

      var deeplinkMethods = {
        // Takes the window's hash and grabs the appropriately defined target and feeds it to the section
        deeplink: function () {
          var targetSection;
          var $targetSection;

          if (debug) {
            console.log('deeplink fn', window.location.hash);
          }

          if (window.location.hash.length !== 0) {
            targetSection = window.location.hash.split('/')[1];
            $targetSection = $('#supreme-power_section-' + targetSection);

            if ($targetSection.data('section') != null && $targetSection.length !== 0) {
              $targetSection.data('section').deeplink();
            }

            return true;
          }

          return false;
        },
        getDeeplink: function () {
          if (window.location.hash.length !== 0) {
            var targetSection = window.location.hash.split('/')[1];
            var $targetSection = $('#supreme-power_section-' + targetSection);

            if ($targetSection.length !== 0) {
              return $targetSection;
            }
          }

          return $('.supreme-power_section').first();
        },
        // Set the deeplink target if its new and don't disturb search history
        setDeeplink: (function () {
          var current = '#/';

          return function (hash) {
            if (hash === current) {
              return false;
            }

            current = hash;
            location.replace(hash);
          };
        }()),
        setPageview: (function () {
          var currentPage = '';
          var currentView = '';

          return function (page, view) {
            if (page == null) {
              return;
            }

            if (view == null) {
              view = '';
            }

            if (currentPage === page && currentView === view) {
              return;
            }

            currentPage = page;
            currentView = view;
            $body.trigger('PageView', [currentPage, currentView]);
          };
        }())
      };
      var postLoad = function () {
        // DOM
        var $closeButton = $videoModal.find('.close_btn');
        var $playPauseButton = $videoModal.find('.play_btn');
        var $scrubber = $videoModal.find('.scrubber');
        // LOGIC
        // Resize handler that should trigger resize handling with a delay after a resize
        var resizeHandler = (function () {
          var resizeTimeout = null;

          return function () {
            // Do not allow resizeTimeout creation until timer run and resizeTimeout is undefined again
            if (resizeTimeout != null) {
              return;
            }

            resizeTimeout = window.setTimeout(function () {
              /*
                   Required for section load, unload, and update functions called by this function
                   There may be additional animations and functionality implemented in those functions that need to be called.
                   Calling this after resize insures that sections "now" in view get updated while sections that are "now" out of view are unloaded
                */
              MAIN.update(true);

              // Add mobile class if desktop class scales under mobile size
              if ($body.hasClass('desktop')) {
                if ($window.width() <= mobileSize && !$body.hasClass('mobile')) {
                  $body.addClass('mobile');
                  isMobile = true;
                  $(window).trigger('desktopGainedMobile');
                } else if ($window.width() > mobileSize && $body.hasClass('mobile')) {
                  $body.removeClass('mobile');
                  isMobile = false;
                  $(window).trigger('desktopLostMobile');
                }
              }

              $window.trigger('update_liftoff_offset');

              // Clear timeout for re-creation
              resizeTimeout = null;
            }, 500);
          };
        })();

        if (debug) {
          console.log('postLoad fired');
        }

        $window.on('scroll touchmove', function (e) {
          var $activeSections = $('.supreme-power_section.active');
          var targetSectionID;

          if (stopScroll) {
            e.preventDefault();

            return false;
          }

          /*
               Required for section load, unload, and update functions called by this function
               There may be additional animations and functionality implemented in those functions that need to be called.
            */
          MAIN.update(true);

          if ($activeSections.length === 0) {
            return;
          }

          // Update deeplink if not currently deeplinking, if there are sections, and window isn't at maximum scroll
          if (!deeplinking && $activeSections.length !== 0 && $window.scrollTop() !== $('body').height() - $(window).height()) {
            targetSectionID = $activeSections.first().attr('id');
            // Updated deeplink to last section if window is at maximum scroll
            // Implemented due to previous section catching deeplink conditions, while the last section almost never does
          } else if ($window.scrollTop() === $('body').height() - $(window).height()) {
            targetSectionID = $activeSections.last().attr('id');
          }

          if (targetSectionID != null) {
            deeplinkMethods.setDeeplink('#/' + targetSectionID.replace(/\D/g, ''));
            // Assume last section
          } else {
            deeplinkMethods.setDeeplink('#/4');
          }
        }).trigger('scroll');

        // Trigger postLoad event
        $window.trigger('postLoad');

        // on resize update MAIN and update desktop/mobile classes
        $window.resize(resizeHandler).trigger('resize');

        $videoModal.find('.close_btn').on('click', function (e) {
          // DOM
          var $video = $videoModal.find('video');

          e.preventDefault();

          if ($video.length !== 0) {
            $video[0].pause();
          }

          $videoModal.removeClass('active');
        });

        // Rebuild and bind events on click (not doing so causes events to do nothing)
        $('a.video').on('click', function (e) {
          // DOM
          var $video = $videoModal.find('.video video').add($videoModal.find('.video'));

          e.preventDefault();

          $video
            .off('ended pause play playing')
            .on('ended', function () {
              $closeButton.trigger('click');
            })
            .on('pause', function () {
              $playPauseButton.removeClass('active');
            })
            .on('play playing', function () {
              $playPauseButton.addClass('active');
            })
            .on('timeupdate', function () {
              // LOGIC
              var progress = (this.currentTime / this.duration) * 100;

              TweenMax.set($scrubber.find('.inner_scrubber'), { width: progress + '%' });
            });
        });

        $playPauseButton.on('click', function (e) {
          // DOM
          var $this = $(this);
          var $video = $videoModal.find('video');

          e.preventDefault();

          if ($video.length === 0) {
            return;
          }

          if ($video[0].paused) {
            $this.addClass('active');
            $video[0].play();
          } else {
            $this.removeClass('active');
            $video[0].pause();
          }

          /*
            // HTML 5 Video
            if ($video.find('video').length !== 0) {
              videoPaused = $video.find('video')[0].paused;
              if (videoPaused)
                $video.html5mediaplayer('play');
              else
                $video.html5mediaplayer('pause');

            //  Youtube video
            } else {
              videoPaused = $video.youtubeplayer('info').state === 2 || $video.youtubeplayer('info').state === 5;
              if (videoPaused)
                $video.youtubeplayer('play');
              else
                $video.youtubeplayer('pause');
            }
            */
        });

        $scrubber.on('click', function (e) {
          var $this = $(this);
          var video = $videoModal.find('video')[0];
          var progress = (e.clientX - $this.offset().left) / $this.width();

          e.preventDefault();

          video.currentTime = video.duration * progress;
        });
      };
      // Customize global sector JS functionality here
      var generateSection = function ($element, options) {
        var elementId = $element.attr('id');

        if ($element == null || $element.length === 0) {
          return;
        }

        options = $.extend({}, options);

        return {
          element: $element,
          load: function () {
            if (debug) {
              console.log(elementId + ': load');
            }

            if (typeof options.load === 'function') {
              options.load.apply(this, arguments);
            }
          },
          unload: function () {
            if (debug) {
              console.log(elementId + ': unload');
            }

            $element.removeClass('active');

            if (typeof options.unload === 'function') {
              options.unload.apply(this, arguments);
            }
          },
          update: function () {
            if (debug) {
              console.log(elementId + ': update');
            }

            if (arguments[0] >= 0.4) {
              $element.addClass('active');
            } else {
              $element.removeClass('active');
            }

            if (typeof options.update === 'function') {
              options.update.apply(this, arguments);
            }
          },
          deeplink: function () {
            var offset = $element.offset().top;

            if (debug) {
              console.log(elementId + ': deeplink');
            }

            deeplinking = true;
            TweenMax.to($window, 1, {
              scrollTo: offset,
              onComplete: function () {
                deeplinking = false;
              }
            });

            // Ensure the deeplinking is "off" after a second
            window.setTimeout(function () {
              deeplinking = false;
            }, 1000);

            if (typeof options.deeplink === 'function') {
              options.deeplink.apply(this, arguments);
            }
          }
        };
      };

      $(window).on('postLoad', function () {
        // Create quickshops
        // $('.quick-shop_btn a, a.shop_now').quickshop();

        // ///////////////////////////////////////////////////////////////////////////////////////////////////
        // BEGIN: Section 1
        // ///////////////////////////////////////////////////////////////////////////////////////////////////
        (function () {
          var $self = $('#supreme-power_section-1');
          var $landingVideoContainer = $self.find('.video-container');
          var $backgroundContainer = $self.find('.background-container');
          var $landingVideo = $self.find('.video-container .video');
          var $videoText = $self.find('.intro-text-container');
          var $introText = $self.find('.text-container').children();
          var $productsContainer = $self.find('.product-container');
          var timeline;

          if ($self == null || $self.length === 0) {
            return;
          }

          if (debug) {
            console.log($introText);
          }

          // BEGIN: Init
          {
            // BEGIN: Animations
            TweenMax.set($productsContainer.find('.shine'), { transformOrigin: '50% 50%' });

            // Mobile animations
            if (isMobile) {
              timeline = new TimelineMax({
                paused: true,
                delay: 0.25
              });

              timeline
                .from($backgroundContainer, 1, {
                  opacity: 0,
                  ease: Power4.easeOut
                })
                .from($productsContainer, 1, { opacity: 0 })
                .fromTo([$self.find('.mobile_header').not('.mobile'), $self.find('.text-container')], 1, {
                  opacity: 0,
                  y: '10%'
                }, {
                  opacity: 1,
                  y: '0%'
                });
            }
            // Desktop animations
            else {
              timeline = new TimelineMax({
                paused: true,
                delay: 0.25
              });

              // timelineTweens.push(TweenMax.to($landingVideoContainer.add($videoText), 1, { opacity : 0, display : 'none', ease : Power1.easeOut }));
              timeline
                .set($introText.filter('.mobile_header').first(), {
                  opacity: 0,
                  ease: Power2.easeIn
                })
                .set([$landingVideoContainer, $videoText], { display: 'none' })
                .add([
                  TweenMax.from($backgroundContainer, 1, { opacity: 0 }),
                  TweenMax.staggerFrom($introText, 0.8, {
                    opacity: 0,
                    ease: Power2.easeIn
                  }, 0.2, '0.3'),
                  TweenMax.from($productsContainer, 0.8, {
                    opacity: 0,
                    y: '+4%',
                    ease: Power2.easeIn,
                    delay: 0.5
                  })
                ], '+=0', 'normal', 0.05)

                .fromTo($productsContainer.find('.glow'), 1.5, {
                  opacity: 0,
                  scale: 1
                }, {
                  opacity: 1,
                  scale: 1,
                  ease: Back.easeOut.config(3)
                })
                .fromTo($productsContainer.find('.shine'), 1.5, {
                  rotation: -90,
                  opacity: 0,
                  scale: 2
                }, {
                  scale: 1,
                  rotation: 0,
                  opacity: 0.95,
                  ease: Back.easeOut.config(3)
                });
            }
            // END: Animations
          }
          // END: Init

          // ////////////////////
          // events
          // ////////////////////
          {
            $landingVideo
              .on('playing.player', function () {
                if (debug) {
                  console.log('section-1: event: playing');
                }

                // Once only function
                var timeUpdateCallBack = (function () {
                  var called = false;

                  return function () {
                    if (called) {
                      return;
                    }

                    if ($landingVideo.find('video')[0].currentTime > 0.9) {
                      called = true;
                      TweenMax.fromTo($videoText, 1, { opacity: 0 }, {
                        opacity: 1,
                        ease: Power4.easeOut
                      });
                    }
                  };
                })();

                $landingVideo.find('video')[0].ontimeupdate = timeUpdateCallBack;

              // timeline.play();
              })
              .on('ended.player', function () {
                if (debug) {
                  console.log('section-1: event: ended');
                }

                timeline.play();
              });

            if (isMobile) {
              window.setTimeout(function () {
                timeline.play();
              }, 1000);
            }

            if (isIpad) {
              $self.find('.misc').one('click', function () {
                var $this = $(this);

                TweenMax.to($this, 0.5, {
                  opacity: 0,
                  display: 'none'
                });
                $landingVideo.player('play');
              });
            }

            $self.find('.shop_now').on('click', function (e) {
              // DOM
              var $this = $(this);
              // LOGIC
              var productData = $this.data('full_product_json');

              e.preventDefault();

              // Must have product data
              if (productData == null) {
                return;
              }

              site.quickshop(productData);
            });

            // Mobile only functionality where clicking on an .el-product_shop-now button scrolls to mpp content
            $self.find('.el-product_shop-now').on('click', function (e) {
              e.preventDefault();

              if (!isMobile) {
                return;
              }

              TweenMax.to($window, 0.5, {
                scrollTo: {
                  y: $('#spp-howtouse-headline').offset().top - $('header').height(),
                  autoKill: false
                }
              });
            });
          }

          if ($self.length !== 0) {
            MAIN.add(generateSection($self, {
              load: function () {
                var dataUrl = $landingVideo.data('url-html');
                var dataYt = $landingVideo.data('url-yt');

                if (!$self.hasClass('init')) {
                  // Uses youtube link if it's available, otherwise html video link
                  if (dataYt != null && dataYt.length > 0) {
                    $landingVideo.youtubeplayer('init', dataYt, $.extend(options.videoYoutube, {
                      autoplay: true,
                      loop: false
                    }));
                  } else if (dataUrl != null && dataUrl.length > 0) {
                    $landingVideo.html5mediaplayer('player', dataUrl, $.extend(options.video, {
                      autoplay: !isIpad,
                      debug: false,
                      loop: false
                    })).addClass('video');
                    $landingVideo.find('video').removeAttr('controls');
                  }

                  $self.addClass('init');
                }
              }
            }));
          }
        })();
        // ///////////////////////////////////////////////////////////////////////////////////////////////////
        // END: Section 1
        // ///////////////////////////////////////////////////////////////////////////////////////////////////

        // ///////////////////////////////////////////////////////////////////////////////////////////////////
        // BEGIN: Section 2
        // ///////////////////////////////////////////////////////////////////////////////////////////////////
        (function () {
          var $self = $('#supreme-power_section-2');
          var $rollovers = $self.find('.plus-rollover');
          var $left = $self.find('.rotating-quotes').add($self.find('.background-container'));
          var $video = $self.find('.video-container .video');
          var timelineTweens = [];
          var timeline;
          var timelineComplete = false;

          // Inits section rollover events
          function initRolloverEvents() {
            // Create rollover event handling after the section receives 'intro_complete' event
            // This is to prevent animation overlap which will prevent intro/rollover animations from functioning correctly
            $rollovers
              .on('mouseenter', function (e) {
                var $this = $(this);
                var $plus = $this.children('a');
                var $text = $this.find('.rollover-text');
                var timeline = new TimelineMax({ paused: true });

                if (isMobile || isIpad) {
                  e.preventDefault();

                  return;
                }

                TweenMax.killTweensOf([$plus, $text, $this]);

                timeline
                  .to($plus, 0.5, { opacity: 0.4 })
                  .set($text, {
                    height: 'auto',
                    ease: Power4.easeInOut
                  }, '0')
                  .from($text, 0.5, {
                    height: 0,
                    ease: Power4.easeInOut,
                    immediateRender: false
                  }, '0')
                  .to($text, 0.3, {
                    opacity: 1,
                    visibility: 'visible',
                    ease: Power4.easeInOut
                  }, '-=0.2')
                  .fromTo($this, 0.5, { marginBottom: '14%' }, {
                    marginBottom: '-10%',
                    ease: Power4.easeInOut,
                    onComplete: function () {
                      $this.addClass('open');
                    }
                  }, '0');

                timeline.play();
              })
              .on('mouseleave', function (e) {
                var $this = $(this);
                var $plus = $this.children('a');
                var $text = $this.find('.rollover-text');
                var timeline = new TimelineMax({ paused: true });

                if (isMobile || isIpad) {
                  e.preventDefault();

                  return;
                }

                TweenMax.killTweensOf([$plus, $text]);

                timeline
                  .to($text, 0.6, {
                    opacity: 0,
                    ease: Power4.easeInOut
                  }, '0')
                  .to($plus, 0.4, { opacity: 1 }, '0.2')
                  .to($text, 0.4, {
                    height: 0,
                    ease: Power4.easeInOut
                  }, '0.2')
                  .to($rollovers, 0.4, {
                    marginBottom: '14%',
                    clearProps: 'marginBottom',
                    ease: Power4.easeInOut,
                    onComplete: function () {
                      $rollovers.removeClass('open');
                    }
                  }, '0.2');

                timeline.play();
              })
            // click toggle to open/close rollovers
              .on('click', function (e, mobileOverride) {
                var $this = $(this);
                var isOpen = $this.hasClass('open');
                var $plus = $this.children('a');
                var $text = $this.find('.rollover-text');
                var $target = $(e.target);
                var timeline = new TimelineMax({ paused: true });

                // Special case for links clicked within rollover
                if ($target.closest('.rollover-text').length !== 0 && $target.is('a')) {
                  return;
                }

                e.preventDefault();

                if ((isIpad || isMobile) && !mobileOverride) {
                  return;
                }

                TweenMax.killTweensOf([$plus, $text]);
                TweenMax.set($rollovers, { margin: '' });

                if (isOpen) {
                  $this.css({ height: '' });

                  timeline
                    .to($text, 0.6, {
                      opacity: 0,
                      ease: Power4.easeInOut
                    }, '0')
                    .to($plus, 0.4, { opacity: 1 }, '0.2')
                    .to($text, 0.4, {
                      height: 0,
                      ease: Power4.easeInOut
                    }, '0.2');

                  $this.removeClass('open');

                  timeline.play();
                } else {
                  timeline
                    .to($plus, 0.5, { opacity: 0.4 })
                    .set($text, { height: 'auto' }, '0')
                    .from($text, 0.5, {
                      height: 0,
                      immediateRender: false
                    }, '0')
                    .to($text, 0.3, {
                      opacity: 1,
                      visibility: 'visible'
                    }, '-=0.2');

                  timeline.play();
                  $this.addClass('open');
                }
              })
              .swipe({
                tap: function () {
                  $(this).trigger('click', [true]);
                },
                excludedElements: 'button, input, select, textarea, .noSwipe'
              });
          }

          if ($self == null || $self.length === 0) {
            return;
          }

          // ////////////////////
          // animations
          // ////////////////////
          {
            timelineTweens.push(TweenMax.from($left, 1, {
              opacity: 0,
              y: '+20%',
              ease: Power1.easeIn
            }));
            timelineTweens.push(TweenMax.staggerFrom($rollovers.toArray(), 1.5, {
              opacity: 0,
              ease: Power4.easeOut
            }, 0.2));

            timeline = new TimelineMax({
              tweens: timelineTweens,
              paused: true,
              stagger: 0.5,
              onComplete: function () {
                if (!timelineComplete) {
                  $self.trigger('intro_complete');
                  timelineComplete = true;
                  initRolloverEvents();
                }
              }
            });
          }

          // ////////////////////
          // events
          // ////////////////////
          {
            $self.find('video').on('loadeddata', function () {
              $(this)[0].play();
            });
          }

          if ($self.length !== 0) {
            MAIN.add(generateSection($self, {
              load: function () {
                var dataUrl = $video.data('url-html');
                var dataYt = $video.data('url-yt');

                if (!$self.hasClass('init')) {
                  if (!isIpad) {
                    // Uses youtube link if it's available, otherwise html video link
                    if (dataYt != null && dataYt.length > 0) {
                      $video.youtubeplayer('init', dataYt, options.videoYoutube);
                    } else if (dataUrl != null && dataUrl.length > 0) {
                      $video.html5mediaplayer('player', dataUrl, $.extend({ autoplay: '0' }, options.video, {
                        debug: false,
                        loop: true
                      })).addClass('video');
                      $video.find('video').removeAttr('controls');
                    }
                  }

                  $self.addClass('init');
                }
              },
              update: function (visible) {
                if (visible >= 0.3 && !timelineComplete) {
                  timeline.play();
                  $video.player('play');
                }
              }
            }));
          }
        })();
        // ///////////////////////////////////////////////////////////////////////////////////////////////////
        // END: Section 2
        // ///////////////////////////////////////////////////////////////////////////////////////////////////

        // ///////////////////////////////////////////////////////////////////////////////////////////////////
        // BEGIN: Section 3
        // ///////////////////////////////////////////////////////////////////////////////////////////////////
        (function () {
          // DOM
          var $self = $('#supreme-power_section-3');
          var $liftoffTarget;
          var $scrollDetails = $self.find('.scroll-details');
          var $scrollText = $self.find('.scroll-details-text');
          var $scrollDetailsNav = $self.find('.scroll-details_nav');
          var $scrollDraggable = $self.find('.scroll-details_draggable_container');
          var $video = $self.find('.video-container .video');
          var $modalVideo; // Video to be played in modal
          var $textContainer = $self.find('.text-container');
          // LOGIC
          var mobileDraggable;
          var mobileDraggableVars = {
            type: 'y',
            bounds: $scrollDraggable.parent(),
            lockAxis: true,
            zIndexBoost: false,
            throwProps: true,
            onDrag: dragHandler,
            onThrowUpdate: dragHandler,
            onPress: function () {
              stopScroll = true;
            },
            onRelease: function () {
              stopScroll = false;
            }
          };
          var videoPlayOnce = (function () {
            var played = false;

            if (isMobile) {
              return;
            }

            return function () {
              if (played) {
                return;
              }

              played = true;

              $video.player('play');
            };
          })();

          if ($self == null || $self.length === 0) {
            return;
          }

          // Centers the liftoff target in the center of the page
          function getOffset() {
            return { offset: ($(window).height() - $self.height()) / 2 - $self.prev().outerHeight(true) };
          }

          // Draggable update handler
          function dragHandler() {
            var y = mobileDraggable.y;
            var progress = Math.abs((y - mobileDraggable.maxY) / (mobileDraggable.maxY - mobileDraggable.minY));

            $scrollDetailsNav.find('li').eq(Math.round(progress / (1 / 3))).addClass('active').siblings().removeClass('active');
          }

          // Prep for liftoff regardless of platform
          $('.liftoff_target').wrapAll('<div id="liftoff_target"></div>');
          $liftoffTarget = $('#liftoff_target');

          if ($body.hasClass('desktop') || isIpad) {
            // Create liftoff
            if ($(window).width() >= mobileSize) {
              $liftoffTarget.liftoff(Math.floor($scrollDetails.position().top) + $scrollDetails.height(), getOffset());
              $liftoffTarget.liftoffUpdate();
            } else {
              // $scrollText.first().addClass('active').siblings().removeClass('active');
              // Mark first dot nav as active
              $scrollDetailsNav.find('li').first().addClass('active').siblings().removeClass('active');

              // Create draggable for in section scroll
              mobileDraggable = Draggable.create($scrollDraggable, mobileDraggableVars)[0];
            }

            // Triggers transition between desktop to mobile or mobile to desktop mode (desktop functionality only)
            $(window).on('desktopGainedMobile', function () {
              if (!$liftoffTarget.hasClass('liftoff_disabled')) {
                $liftoffTarget.liftoffDisable();
                // Blow away everything
                $liftoffTarget.css({
                  top: '',
                  position: '',
                  height: '',
                  width: '',
                  left: ''
                });
                $liftoffTarget.closest('.liftoff_wrapper').css({
                  height: '',
                  position: ''
                });
                $liftoffTarget.removeClass('liftoff_finished');
              }

              $scrollText.first().addClass('active').siblings().removeClass('active');
              $scrollDetailsNav.find('li').first().addClass('active').siblings().removeClass('active');

              // Create draggable for in section scroll
              mobileDraggable = Draggable.create($scrollDraggable, mobileDraggableVars)[0];
            })
              .on('desktopLostMobile', function () {
                $scrollText.removeClass('active');

                // create liftoff in desktop mode if it started in mobile-desktop mode
                if ($liftoffTarget.data('liftoff') == null) {
                  $liftoffTarget.liftoff(Math.floor($scrollDetails.position().top) + $scrollDetails.height(), getOffset());
                }

                if ($liftoffTarget.hasClass('liftoff_disabled')) {
                  $liftoffTarget.liftoffEnable();
                  $liftoffTarget.closest('.liftoff_wrapper').css({ position: 'relative' });
                  $liftoffTarget.liftoffUpdate();
                }

                if (mobileDraggable != null) {
                  mobileDraggable.kill();
                }

                $scrollDraggable.css({ transform: '' });
              });
          } else {
            // Draggable for section 3 top text
            // Create draggable for in section scroll
            mobileDraggable = Draggable.create($scrollDraggable, mobileDraggableVars)[0];
          }

          // ////////////////////
          // Events
          // ////////////////////
          {
            // Progress draggable y position on li click, position based on index
            $scrollDetailsNav.find('li').on('click', function (e) {
              var $this = $(this);
              var index = $this.index();
              var y;

              e.preventDefault();

              if (Draggable.get($scrollDraggable) != null) {
                y = mobileDraggable.y;
                TweenMax.to($scrollDraggable, 0.5, { y: mobileDraggable.minY * (index / ($scrollDetailsNav.find('li').length - 1)) });
              }

              $this.addClass('active').siblings().removeClass('active');
            });

            // Update text position on liftoff progress
            $liftoffTarget.on('liftoff_update', function (e, progress) {
              TweenMax.set($scrollDetails, { y: -Math.floor(110 * progress) + '%' });
            });

            // Update the liftoff offset so that section 3 stays in the middle of the screen, when update_liftoff gets fired
            $(window).on('update_liftoff_offset', function () {
              if ($liftoffTarget.data('liftoff') != null && !$liftoffTarget.hasClass('liftoff_disabled')) {
                $liftoffTarget.data('liftoff').offset = getOffset().offset;
                $liftoffTarget.liftoffUpdate();
              }
            });

            // Ensures that the liftoff offset is adjusted correctly once the video's height inflates the section
            $('.video').on('init.player ready loadstart loadedmetadata', function () {
              if ($liftoffTarget.data('liftoff') != null && !$liftoffTarget.hasClass('liftoff_disabled')) {
                $liftoffTarget.data('liftoff').offset = getOffset().offset;
                $liftoffTarget.liftoffUpdate();
              }
            });

            // Trigger a video modal
            $self.find('a.video').on('click', function (e) {
              e.preventDefault();
              e.stopPropagation();

              if (isMobile) {
                $modalVideo.css({
                  opacity: 1,
                  display: 'block'
                });
                $modalVideo[0].play(0);
                $self.find('.close_btn').css({
                  display: '',
                  opacity: ''
                });
              } else {
                $videoModal.addClass('active');
                $videoModal.find($(this).data('target')).addClass('active');
                $videoModal.find('video')[0].play();
              }
            });

            $textContainer.on('click', function (e) {
              e.preventDefault();

              if (!isMobile) {
                $self.find('a.video').first().trigger('click');
              }
            });

            // BEGIN: Mobile
            // Mobile only functionality that hides the video in the header
            if (isMobile) {
              $self.find('.close_btn').on('click', function (e) {
                // DOM
                var $this = $(this);

                e.preventDefault();

                if (!isMobile) {
                  return;
                }

                if ($modalVideo != null && $modalVideo.length !== 0) {
                  $modalVideo.css({ opacity: 0 });
                  $modalVideo[0].pause();
                  $this.css({
                    display: 'none',
                    opacity: 0
                  });
                }
              });
            }
            // END: Mobile
          }

          if ($self.length !== 0) {
            MAIN.add(generateSection($self, {
              load: function () {
                var dataUrl = $video.data('url-html');
                var dataYt = $video.data('url-yt');

                if (!$self.hasClass('init')) {
                  // Uses youtube link if it's available, otherwise html video link
                  // This is for inline section
                  if (dataYt != null && dataYt.length > 0) {
                    $video.youtubeplayer(dataYt, options.videoYoutube);
                  } else if (dataUrl != null && dataUrl.length > 0) {
                    $video.html5mediaplayer('player', dataUrl, $.extend({ autoplay: '0' }, options.video, {
                      debug: false,
                      loop: false
                    })).addClass('video');
                    $video.find('video').removeAttr('controls');
                  }

                  if (isMobile) {
                    $modalVideo = $self.find('.header-container video');
                    $modalVideo.find('source').attr('src', $self.find('a.video').attr('href'));
                    $self.find('.close_btn').css({
                      display: 'none',
                      opacity: 0
                    });

                    $modalVideo.on('ended', function () {
                      $self.find('.close_btn').trigger('click');
                    });

                    // Clear link to prevent modal functionality
                    $self.find('a.video').attr('href', '#');
                  }

                  $self.addClass('init');
                }
              },
              update: function (visible) {
                if (visible >= 0.5 && !isMobile) {
                  videoPlayOnce();
                }
              }
            }));
          }
        })();
        // ///////////////////////////////////////////////////////////////////////////////////////////////////
        // END: Section 3
        // //////////////////////////////////////////////////////////////////////////////////////////////////

        // ///////////////////////////////////////////////////////////////////////////////////////////////////
        // BEGIN: Section 4
        // //////////////////////////////////////////////////////////////////////////////////////////////////
        (function () {
          var $self = $('#tips_section-3');
          var $carousel = $self.find('.carousel');
          // Mobile animation vars
          var $currentSlide;
          var updateCarouselOnResize;
          // DOM
          var $arrowLeft = $self.find('.carousel_pagers .arrow.left');
          var $arrowRight = $self.find('.carousel_pagers .arrow.right');
          // LOGIC
          var productsCarouselInit = false;

          if ($self.length === 0) {
            return;
          }

          $(window).trigger('resize');

          /**
          * @function updateCarouselOnResize
          * @description Handler for mobile mode resize, carousel update, ensures that positions are reapplied
          * returns {undefined} this function does not return anything
          */
          updateCarouselOnResize = (function () {
            $carousel.carouselUpdate();
          })();

          /**
          * @function setMobileMode
          * @description Clears events used for desktop
          * @returns {undefined} this function does not return anything
          */
          function setMobileMode() {
            $currentSlide = $();

            // Enable carousel
            $carousel.carouselSetEnabled(false);
            $carousel.carouselUpdate();

            $carousel.carouselDestroy();
            $carousel.el_carousel({
              useGSAP: true,
              offset: '3%',
              increment: '50%',
              duration: 0.5
            });

            $window.on('resize', updateCarouselOnResize);

            // Carousel controls
            $arrowLeft.on('click', function (e) {
              e.preventDefault();

              $carousel.carouselPrev();
            });

            $arrowRight.on('click', function (e) {
              e.preventDefault();

              $carousel.carouselNext();
            });

            $self.swipe('enable');
          }

          /**
          * @function setDesktopMode
          * @description Creates events needed for desktop functionality
          * @returns {undefined} This function doesn't return anything
          */
          function setDesktopMode() {
            $currentSlide = $();

            // Enable carousel
            $carousel.carouselSetEnabled(true);
            $carousel.carouselUpdate();

            $carousel.carouselDestroy();

            $carousel.el_carousel({
              useGSAP: true,
              offset: '5%',
              increment: '33.3%',
              duration: 0.5
            });

            $window.on('resize', updateCarouselOnResize);

            // Carousel controls
            $arrowLeft.on('click', function (e) {
              e.preventDefault();

              $carousel.carouselPrev();
            });

            $arrowRight.on('click', function (e) {
              e.preventDefault();

              $carousel.carouselNext();
            });

            $window.on('keydown', function (e) {
              e.preventDefault();

              if (!$self.hasClass('active')) {
                return;
              }

              switch (e.which) {
                // Left arrow
                case 37:

                  $carousel.carouselPrev();
                  break;

                // Right arrow
                case 39:

                  $carousel.carouselNext();
                  break;
              }
            });

            $self.swipe('enable');
          }

          // BEGIN: Events
          {
            $window.one('products-ready', function () {
              if (productsCarouselInit) {
                return;
              }

              productsCarouselInit = true;

              // Enable or disable desktop/mobile functionality
              if (!isMobile) {
                setDesktopMode();
              } else {
                setMobileMode();
              }

              // Events to trigger desktop/mobile functionality
              $window
                .on('desktopLostMobile', setDesktopMode)
                .on('desktopGainedMobile', setMobileMode);
            });

            if (productsReady && !productsCarouselInit) {
              productsCarouselInit = true;

              // Enable or disable desktop/mobile functionality
              if (!isMobile) {
                setDesktopMode();
              } else {
                setMobileMode();
              }

              // Events to trigger desktop/mobile functionality
              $window
                .on('desktopLostMobile', setDesktopMode)
                .on('desktopGainedMobile', setMobileMode);

              $window.off('products-ready');
            }

            // Swipe events, this will be enabled/disabled via setDesktopMode/setMobileMode
            $self.swipe({
              swipeLeft: function () {
                $carousel.carouselNext();
              },
              swipeRight: function () {
                $carousel.carouselPrev();
              },
              allowPageScroll: 'vertical',
              preventDefaultEvents: false
            });

            $self.find('.el-product_shop-now.quickshop').off('click').on('click', function (e) {
              // DOM
              var $this = $(this);
              // LOGIC
              var productData = $this.data('full_product_json');

              e.preventDefault();

              if (productData == null) {
                return;
              }

              site.quickshop(productData);
            });
          }
          // END: Events

          MAIN.add(generateSection($self));
        })();
        // ///////////////////////////////////////////////////////////////////////////////////////////////////
        // END: Section 4
        // //////////////////////////////////////////////////////////////////////////////////////////////////

        // ///////////////////////////////////////////////////////////////////////////////////////////////////
        // END: Section 5
        // ///////////////////////////////////////////////////////////////////////////////////////////////////
        (function () {
          var $self = $siteContainer.find('.supreme-power_section.last');

          if ($self.length !== 0) {
            MAIN.add(generateSection($self));
          }
        })();
        // ///////////////////////////////////////////////////////////////////////////////////////////////////
        // END: Section 5
        // ///////////////////////////////////////////////////////////////////////////////////////////////////
        MAIN.moveTo(0);
        $window.scrollTop(0);
        window.main = MAIN;
        $(window).trigger('postLoadComplete');
      });

      // /////////////////////////////////
      // BEGIN: COREMETRICS
      // /////////////////////////////////
      (function () {
        var forceFlag;
        var cmSettings;

        if (window.location.href.indexOf('dynamic.li') > -1) {
          return;
        }

        forceFlag = $siteContainer.hasClass('it_IT') ? 1 : 0;
        cmSettings = {
          options: {
            debug: debug,
            cat_id: 'CAT', // CAT ID
            element_cat: 'Estee Supreme Boutique', // Boutique Name
            force: forceFlag// Force CoreMetrics on some servers
          },
          section: [
            {
              tag: 'Landing',
              element_tag: {

              }
            }
          ]
        };
        $siteContainer.elmetrics(cmSettings);
      })();
      // ///////////////////////////////////
      // END: COREMETRICS
      // ///////////////////////////////////

      // /////////////////////////////////
      // BEGIN: Preloader
      // /////////////////////////////////
      (function () {
        var $loader = $siteContainer.find('#loader');
        var preloadTargets = [];
        var spinnerOptions = {
          lines: 21, // The number of lines to draw
          length: 0, // The length of each line
          width: 5, // The line thickness
          radius: 40, // The radius of the inner circle
          scale: 1, // Scales overall size of the spinner
          corners: 1, // Corner roundness (0..1)
          color: '#1e1e1e', // #rgb or #rrggbb or array of colors
          opacity: 0.5, // Opacity of the lines
          rotate: 0, // The rotation offset
          direction: 1, // 1: clockwise, -1: counterclockwise
          speed: 1.3, // Rounds per second
          trail: 100, // Afterglow percentage
          fps: 20, // Frames per second when using setTimeout() as a fallback for CSS
          zIndex: 2e9, // The z-index (defaults to 2000000000)
          className: 'spinner', // The CSS class to assign to the spinner
          top: '50%', // Top position relative to parent
          left: '50%', // Left position relative to parent
          shadow: false, // Whether to render a shadow
          hwaccel: true, // Whether to use hardware acceleration
          position: 'absolute' // Element positioning
        };
        var spinner = new Spinner(spinnerOptions).spin($loader[0]);
        var $deeplinkSection = deeplinkMethods.getDeeplink();

        // Deeplink'd section gets priority over all other sections
        if ($deeplinkSection.length !== 0) {
          preloadTargets.push($deeplinkSection.find('img, .preload').not(isMobile ? '.desktop' : '.mobile'));
          $deeplinkSection.siblings('.supreme-power_section').each(function () {
            preloadTargets.push($(this).find('img, .preload').not(isMobile ? '.desktop' : '.mobile'));
          });
        } else {
          $('.supreme-power_section').each(function () {
            preloadTargets.push($(this).find('img, .preload').not(isMobile ? '.desktop' : '.mobile'));
          });
        }

        // Run EL Product plugin
        $('#supreme-power_section-1, #tips_section-3 .carousel_container').elproduct({
          'target': '.el-product',
          'template': '.hidden-products-markup-to-clone li.el-product',
          'products': '.el-product_id-list',
          'debug': false,
          onSuccess: function () {
            // Remove empty product slides
            $('#tips_section-3 .carousel_container .carousel .slide').each(function () {
              // DOM
              var $this = $(this);
              // LOGIC
              var hasProduct = false;
              var dataProduct = $this.data('product');
              var dataAttribute = $this.attr('data-product');

              // Has jQuery.data('product') populated
              if (typeof dataProduct === 'string' && dataProduct.trim().length !== 0) {
                hasProduct = true;
              }

              // Has HTML data-attribute populated
              if (typeof dataAttribute === 'string' && dataAttribute.trim().length !== 0) {
                hasProduct = true;
              }

              if (!hasProduct) {
                $this.remove();
              } else {
                $this.css('display', 'block');
              }
            });

            productsReady = true;
            $window.trigger('products-ready');
          }

        });

        $window.on('postLoad', function () {
          var $liftOffWrapper = $('.liftoff_wrapper');

          TweenMax.to($loader, 1, {
            opacity: 0,
            display: 'none',
            onComplete: function () {
              spinner.stop();

              if (window.location.hash.indexOf('5') !== -1) {
                if (isMobile) {
                  window.setTimeout(function () {
                    TweenMax.to($(window), 1, {
                      scrollTo: {
                        y: $('#liftoff_target').offset().top + $('#liftoff_target').height(),
                        autoKill: false
                      }
                    });
                  }, 3000);
                }
                // Assumes liftoff has been created in desktop mode
                else {
                  $(window).one('update_liftoff_offset', function () {
                    TweenMax.to($(window), 1.5, { scrollTo: { y: $liftOffWrapper.offset().top + $liftOffWrapper.height() } });
                  });
                }
              } else {
                deeplinkMethods.deeplink();
              }
            }
          });
        });

        $(preloadTargets).FreeLoader({
          debug: false,
          loadTimeout: 10000,
          callback: function () {
            // Ensure the rest of the images have been swapped in
            $siteContainer.find('img, .preload').each(function () {
              var $this = $(this);
              var dataSrc = $this.data('src');

              if (dataSrc != null) {
                $this.attr('src', dataSrc);
              }
            });
            postLoad();
          }
        });
      })();
      // /////////////////////////////////
      // END: Preloader
      // /////////////////////////////////

      // /////////////////////////////////
      // END: Video Modal
      // /////////////////////////////////
      // Player Init
      $siteContainer.player('init', {
        'defaults': {
          'controls': false,
          'autohide': 1,
          'modestbranding': 1,
          'autoplay': true,
          'html5': 1,
          // 'playerType' : (OLD_IE) ? 'flash' : 'iframe',
          'preferredQuality': 'hd720' // highres
        },
        'debug': false
      });
      // /////////////////////////////////
      // END: Video Modal
      // /////////////////////////////////
    }
  };
})(jQuery);
